module.exports = __webpack_public_path__ + "img/w3_share_white.b2df854a.png";